export { axiosIns } from "./Axios";
export { auth } from "./Authentication";
export * from "./Api";
